<template>
  <div class="box">
    <div class="row">
      <div class="col-lg-8 box-img-wrapper">
        <VideoWrapper v-if="box.videoURL" :videoLink="box.videoURL"></VideoWrapper>
        <ImageWrapper v-else :file="box.idFile" :key="box.idFile"></ImageWrapper>
      </div>
      <div class="col-lg-4 box-inner">
        <span class="box-tag">
          <span v-if="box._embedded.Content.importSource">{{box._embedded.Content.importSource}}</span>
          <span>{{ box.date | formatDate2 }}</span>
          <span>{{readTime(box.contentNew)}} minute read</span>
          <span>{{category ? category.value : 'News'}}</span>
        </span>
        <router-link :to="{name: 'NewsSingle', params: {id: box.idNews}}" class="box-title">
          <span>{{ box.headline }}</span>
        </router-link>
        <div class="box-bottom">
          <span class="span-icon" v-if="box.commentsCounter"><i class="icon-comment"></i> {{box.commentsCounter}}</span>
          <span class="span-icon" v-if="box.likes"><i class="icon-vote-up"></i> {{box.likes}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import {readTime} from "@/helpers/readTime";
import VideoWrapper from "@/components/general/VideoWrapper";
export default {
  name: 'HomeNewsBox',
  components: {VideoWrapper, ImageWrapper},
  props: ['box'],
  methods: {
    readTime: readTime,
  },
  computed: {
    category() {
      return this.$store.getters.sectionByIdSettingCompany(this.box._embedded.Content.idType)
    },
  }
}
</script>
